import { gameEvents } from '../../lib/gameEvents';
import { gameMainDrawer } from './gameMainDrawer';
import { isMobile } from '../../helpers/isMobile';
import { PixiBase } from '../../core/pixi/PixiBase';
import { handleCollect, setContainersPosition } from '../../helpers';
import { spinBarStore } from '../../store/spinBarStore';
import { animationService } from '../../services/animationService';
import { autoBetCounts, containerNames, frameNames } from '../../constants';
import { addKeyboardListener } from '../../core/helpers/keyboard';
import { gameStore } from '../../store/gameStore';
import { applicationStore } from '../../store/applicationStore';
import { soundService } from '../../services';
import { SoundTypes } from '../../services/baseSoundService/soundService';
import { winBarStore } from '../../store/winBarStore';
import { betButtonContainerXPositionHandler } from '../../helpers/betButtonContainerXPositionHandler';
import { betBarStore } from '../../store/betBarStore';
import { gambleStore } from '../../store/gambleStore';
import { clearGameLoopManagerByTime } from '../../lib/gameLoop';
import { loadingStore } from '../../store/loadingStore';

let intervalSpinButtonAnimationId;
let isSpinButtonClicked = false;
const reelSpeedFrameName = {
  standard: frameNames.SlowSpinIcon,
  fast: frameNames.FastSpinIcon,
  faster: frameNames.PumaMode,
};

export class SpinBarDrawer {
  constructor() {
    this.animations = {};
    this.SpinBarContainer = PixiBase.createContainer(containerNames.SpinBarContainer);
    this.SpinBarContainer.y = window.innerHeight;
    this.autoBetPopupContainer = PixiBase.createContainer(containerNames.AutoBetPopupContainer);
    this.winClick = false;
  }

  setupSpinButton() {
    this.spinButtonClickCount = 0;
    this.pgLogo = PixiBase.createSprite(this.spriteSheet.pgLogo);
    this.spinButton = PixiBase.createSprite(this.spriteSheet.spinButton);
    const { x, y, anchor } = this.config.SpinBarContainer.spinButtonConfig;
    PixiBase.setPosition(this.spinButton, { x: x, y: y });
    PixiBase.setPosition(this.pgLogo, { x: x, y: y });
    this.spinButtonCollectMode = PixiBase.createGraphics();
    this.spinButtonCollectMode.lineStyle(0);
    this.spinButtonCollectMode.beginFill('red');
    this.spinButtonCollectMode.drawCircle(x, y, 80);
    this.spinButtonCollectMode.alpha = 0;
    this.spinButtonCollectMode.visible = false;
    PixiBase.setupButtonMode(this.spinButtonCollectMode, { interactive: true, buttonMode: true });
    PixiBase.setupButtonMode(this.spinButton, { interactive: true, buttonMode: true });
    PixiBase.registerPointerup(this.spinButton, () => {
      if (isSpinButtonClicked) {
        isSpinButtonClicked = false;
        PixiBase.changeFrame(this.pgLogo, frameNames.PgLogo);
        if (spinBarStore.isSpinStart) {
          spinBarStore.setIsDoubleClick(true);
          return;
        }
        if (spinBarStore.isAutoBetStart) {
          return;
        }
        this.handleDoSpin.call(this);
      }
    });

    PixiBase.registerPointerUpOutside(this.spinButton, () => {
      if (isSpinButtonClicked) {
        isSpinButtonClicked = false;
        PixiBase.changeFrame(this.pgLogo, frameNames.PgLogo);
      }
    });
    PixiBase.registerClick(this.spinButton, () => {
      if (gameMainDrawer.popupBar.isOpenPopup) {
        return;
      }
      isSpinButtonClicked = true;
      PixiBase.changeFrame(this.pgLogo, frameNames.SelectedBetButtonState);
    });
    document.addEventListener('keydown', () => {
      if (!gameStore.isOpenBigWinPopup) {
        PixiBase.changeFrame(this.pgLogo, frameNames.SelectedBetButtonState);
      }
    });

    addKeyboardListener([' ', 'Enter'], () => {
      if (
        !gameStore.isOpenBigWinPopup &&
        !gameMainDrawer.freeBetBar.freeBetPopupContainer.visible
      ) {
        PixiBase.changeFrame(this.pgLogo, frameNames.PgLogo);
      }
    });
    this.pgLogo.anchor.set(anchor);
    this.spinButton.anchor.set(anchor);
    this.SpinBarContainer.addChild(this.spinButton);
    this.SpinBarContainer.addChild(this.pgLogo);
    this.SpinBarContainer.addChild(this.spinButtonCollectMode);
  }

  handleAutoBet() {
    if (
      spinBarStore.isAutoBetStart &&
      spinBarStore.selectedAutoBetCount > 1 &&
      Number.isFinite(spinBarStore.selectedAutoBetCount)
    ) {
      spinBarStore.setSelectedAutoBetCount(spinBarStore.selectedAutoBetCount - 1);
      spinBarStore.autoBetPopupToggle();
      this.selectedAutoBetCount.text = spinBarStore.selectedAutoBetCount;
      return;
    }
    if (spinBarStore.isAutoBetStart && spinBarStore.selectedAutoBetCount <= 1) {
      spinBarStore.setIsAutoBetStart(false);
      spinBarStore.autoBetPopupToggle();
      spinBarStore.setSelectedAutoBetCount(null);
      this.selectedAutoBetCount.text = '';
      PixiBase.changeFrame(this.autoBetButton, frameNames.AutoBetButton);
    }
  }

  handleDoSpin() {
    clearTimeout(gameMainDrawer.betBar.totalWinAmountZeroVisibleTime);
    if (
      winBarStore.isLastWinAmountTextVisible &&
      !+gameMainDrawer.betBar.winAndLastWinAmount.text
    ) {
      gameMainDrawer.betBar.winAndLastWinContainer.visible = Boolean(
        +winBarStore.winAmount || winBarStore.prevWinAmount
      );
    }
    gameMainDrawer.menuBar.soundControllerWrapper.visible = false;
    if (this.autoBetPopupContainer.visible) {
      this.autoBetPopupContainer.visible = false;
      PixiBase.changeFrame(
        this.autoBetButton,
        spinBarStore.selectedAutoBetCount ? frameNames.AutoBetEnableIcon : frameNames.AutoBetButton
      );
    }

    if (
      (gameMainDrawer.menuBar.menuBarPopupContainer.visible && !isMobile()) ||
      gameMainDrawer.popupBar.PopupContainer.visible ||
      loadingStore.gameLoading ||
      (gambleStore.isGamble && gambleStore.isGamblePopupVisible)
    )
      return;
    if (!this.winClick) {
      if (spinBarStore.isSpinStart) {
        spinBarStore.setIsDoubleClick(true);
        return;
      }
      // gameMainDrawer.expandWildBar.wildReelsContainer.children.forEach((reel) => {
      //   reel.visible = false;
      // });
      this.handleAutoBet();
      this.spinButtonAnimation();
      animationService.lastAnimatedReelIndex = 0;
      gameMainDrawer.slotBar.SlotBarContainer.visible = true;
      gameMainDrawer.slotBar.WinBarContainer.visible = false;
      gameMainDrawer.lineWinBar.showAndHideWinCoinsAnimation(false);
      gameEvents.emit('stopWin');
      gameEvents.emit('winPopupAnimEnd');
      clearGameLoopManagerByTime();
      gameEvents.emit('spinStarted');
      gameMainDrawer.betBar.updateQuickBetsState();
      gameMainDrawer.notificationBar.toggleBetNotAcceptedNotification(false);
      spinBarStore.setIsSpinStart(true);
      gameMainDrawer.menuBar.toggleMenuIconOpacity();
      gameMainDrawer.lineWinBar.toggleLineWinBarContainerVisible(false);
      gameStore.setGameResultMatrix([]);
      betButtonContainerXPositionHandler(betBarStore.selectedBetAmountIndex);
      soundService.stop(SoundTypes.WinPopupBigWin);
      winBarStore.setSpinResultOdd(0);
      PixiBase.changeFrame(this.slowSpinButton, reelSpeedFrameName[spinBarStore.gameReelSpeedType]);
      animationService.pulseTimeline && animationService.pulseTimeline.kill();
      spinBarStore.setIsStopAllReels(false);
      if (gambleStore.gambleCount) {
        gambleStore.setIsCollectBeforeSpin(true);
        gameStore.setCollectValidationType(null);
        this.gambleStartButtonContainer.visible = false;
        this.slowSpinButton.visible = true;
        handleCollect();
      } else {
        spinBarStore.doSpin();
      }
    }
  }

  hideAutoBetCountContainer() {
    PixiBase.setupButtonMode(this.graphics, { interactive: false, buttonMode: false });
    this.autoBetPopupContainer.visible = false;
    if (!spinBarStore.selectedAutoBetCount) {
      spinBarStore.setIsAutoBetStopButtonVisible(false);
      PixiBase.changeFrame(this.autoBetButton, frameNames.AutoBetButton);
    }
  }

  hideGambleFeature() {
    PixiBase.changeFrame(this.slowSpinButton, frameNames.SlowSpinIcon);
    gambleStore.setIsGamblePopupVisible(false);
    this.gambleStartButtonContainer.visible = false;
    this.slowSpinButton.visible = true;
    this.spinButton.visible = true;
    this.spinButtonArrows.visible = true;
    this.pgLogo.visible = true;
    animationService.pulseTimeline?.kill();
  }

  handleGambleStartButtonVisibleState() {
    if (
      !spinBarStore.isAutoBetStart &&
      spinBarStore.isStoppedAllReels &&
      gambleStore.gambleCount &&
      !gambleStore.isGamble
    ) {
      this.gambleStartButtonContainer.visible = true;
      this.slowSpinButton.visible = false;
      gambleStore.setIsGamblePopupVisible(true);
      animationService.handleGambleStartButtonPulseAnimation(this.multiplierIcon);
    }
  }

  showSpinButton() {
    this.gambleStartButtonContainer.visible = false;
    this.slowSpinButton.visible = true;
    this.spinButton.visible = true;
    this.spinButtonArrows.visible = true;
    this.pgLogo.visible = true;
  }

  handleGambleStart() {
    gameMainDrawer.gambleBar.gambleFinished = false;
    gameMainDrawer.gambleBar.attemptsLeftCount.visible = true;
    gambleStore.setIsGamble(true);
    gameEvents.emit('winPopupAnimEnd');
    animationService.pulseTimeline?.kill();
    this.gambleStartButtonContainer.visible = false;
    this.slowSpinButton.visible = true;
    this.spinButton.visible = false;
    this.spinButtonArrows.visible = false;
    this.pgLogo.visible = false;
    gameMainDrawer.gambleBar.flipCard.play('idle', true);
    gameMainDrawer.gambleBar.GambleContainer.visible = true;
    gameMainDrawer.gambleBar.isCardAnimationFinished = false;
  }

  setupGraphicsForOutSideClick() {
    this.graphicsContainer = PixiBase.createContainer('graphicsContainer1');
    const graphics = PixiBase.createGraphics();
    this.graphics = graphics;
    this.graphics.visble = false;
    graphics.beginFill(0xff0000);
    graphics.alpha = 0;
    graphics.drawRect(-1600, -750, isMobile() ? 540 : 1950, isMobile() ? 960 : 960);
    graphics.endFill();
    PixiBase.registerClick(graphics, (event) => {
      const eventPosition = event.data.global;
      if (!this.autoBetPopupContainer.getBounds().contains(eventPosition.x, eventPosition.y)) {
        this.hideAutoBetCountContainer();
      }
    });
    this.graphicsContainer.addChild(graphics);
    this.SpinBarContainer.addChild(this.graphicsContainer);
  }

  hideAutoBetPopup() {
    spinBarStore.setIsAutoBetStopButtonVisible(false);
    spinBarStore.setSelectedAutoBetCount(null);
    spinBarStore.setIsAutoBetStart(false);
    this.selectedAutoBetCount.text = '';
    this.autoBetPopupContainer.visible = false;
    PixiBase.changeFrame(this.autoBetButton, frameNames.AutoBetButton);
  }

  showAutoBetPopup() {
    spinBarStore.setIsAutoBetStopButtonVisible(true);
    this.autoBetPopupContainer.visible = true;
    PixiBase.changeFrame(this.autoBetButton, frameNames.AutoBetEnableIcon);
    spinBarStore.autoBetPopupToggle();
    PixiBase.setupButtonMode(this.graphics, { interactive: true, buttonMode: true });
  }

  initAutoBetButton() {
    this.selectedAutoBetCount.text = '';
    PixiBase.changeFrame(this.autoBetButton, frameNames.AutoBetButton);
  }

  setupAutoBetButton() {
    this.autoBetButton = PixiBase.createSprite(this.spriteSheet.autoBetButton);
    const { x, y, anchor } = this.config.SpinBarContainer.autoBetButtonConfig;
    PixiBase.setPosition(this.autoBetButton, { x: x, y: y });
    this.autoBetButton.anchor.set(anchor);
    PixiBase.setupButtonMode(this.autoBetButton, { interactive: true, buttonMode: true });
    PixiBase.registerClick(this.autoBetButton, () => {
      if (gameMainDrawer.popupBar.isOpenPopup) {
        return;
      }
      if (spinBarStore.isAutoBetStopButtonVisible) {
        this.hideAutoBetPopup();
      } else {
        if (spinBarStore.isSpinStart) {
          return;
        }
        this.showAutoBetPopup();
      }
    });
    this.SpinBarContainer.addChild(this.autoBetButton);
  }

  setupSlowModeButton() {
    this.slowSpinButton = PixiBase.createSprite(this.spriteSheet.slowSpinIcon);
    const { x, y, anchor } = this.config.SpinBarContainer.slowSpinButtonConfig;
    PixiBase.setPosition(this.slowSpinButton, { x: x, y: y });
    this.slowSpinButton.anchor.set(anchor);
    PixiBase.setupButtonMode(this.slowSpinButton, { interactive: true, buttonMode: true });
    PixiBase.registerClick(this.slowSpinButton, () => {
      if (gameMainDrawer.popupBar.isOpenPopup) return;
      spinBarStore.updateGameReelSpeedMode();
      gameEvents.emit('updateReelSpeed');
      this.hideAutoBetCountContainer();
      PixiBase.setPosition(this.slowSpinButton, { x: x, y: y });
      PixiBase.changeFrame(this.slowSpinButton, reelSpeedFrameName[spinBarStore.gameReelSpeedType]);
    });
    this.SpinBarContainer.addChild(this.slowSpinButton);
  }

  setupSpinButtonArrowsButton() {
    this.spinButtonArrows = PixiBase.createSprite(this.spriteSheet.spinButtonArrows);
    const { x, y, anchor } = this.config.SpinBarContainer.spinButtonArrowsConfig;
    PixiBase.setPosition(this.spinButtonArrows, { x: x, y: y });
    this.spinButtonArrows.anchor.set(anchor);
    this.SpinBarContainer.addChild(this.spinButtonArrows);
    this.setupDefaultSpinButtonArrowsAnimation();
  }

  setupDefaultSpinButtonArrowsAnimation() {
    intervalSpinButtonAnimationId = setInterval(() => {
      animationService.spinButtonRotateAndReturnAnimation(this.spinButtonArrows);
      animationService.spinButtonScaleAndReturnAnimation(this.spinButton);
    }, 3000);
  }

  spinButtonAnimation() {
    if (this.isStopAnimation) {
      return;
    }
    this.isStopAnimation = true;
    animationService.spinButtonAnimationOnSpinAction(this.spinButtonArrows).then(() => {
      clearInterval(intervalSpinButtonAnimationId);
      this.isStopAnimation = false;
      this.setupDefaultSpinButtonArrowsAnimation();
    });
  }

  setupAutoBetInfinityCountButton() {
    this.autoBetInfinityCountButton = PixiBase.createSprite(this.spriteSheet.infinitiIcon);
    const { x, y, anchor } = this.config.SpinBarContainer.infinityIconConfig;
    PixiBase.setPosition(this.autoBetInfinityCountButton, { x: x, y: y });
    this.autoBetInfinityCountButton.anchor.set(anchor);
    this.autoBetPopupContainer.addChild(this.autoBetInfinityCountButton);
    PixiBase.setupButtonMode(this.autoBetInfinityCountButton, {
      interactive: true,
      buttonMode: true,
    });
    PixiBase.registerClick(this.autoBetInfinityCountButton, () => {
      spinBarStore.setIsAutoBetStopButtonVisible(true);
      spinBarStore.setSelectedAutoBetCount(Infinity);
      spinBarStore.setIsAutoBetStart(true);
      this.autoBetPopupContainer.visible = false;
      PixiBase.changeFrame(this.autoBetButton, frameNames.Infinity);
      this.handleDoSpin();
    });
  }

  setupAutoBetCountsList() {
    autoBetCounts.forEach((count, index) => {
      this.autoBetCount = PixiBase.createText(count, {
        fontSize: isMobile() ? 20 : 18,
        fill: 'white',
        align: 'center',
        fontWeight: 510,
        fontFamily: 'Roboto',
      });
      const { x, y, anchor } = this.config.SpinBarContainer.autoBetCountsConfig;
      PixiBase.setPosition(this.autoBetCount, { x: x, y: y + index * 45 });
      this.autoBetCount.anchor.set(anchor);
      PixiBase.setupButtonMode(this.autoBetCount, { interactive: true, buttonMode: true });
      PixiBase.registerClick(this.autoBetCount, (e) => {
        spinBarStore.setIsAutoBetStopButtonVisible(true);
        spinBarStore.setSelectedAutoBetCount(+e.target.text);
        spinBarStore.setIsAutoBetStart(true);
        this.autoBetPopupContainer.visible = false;
        this.selectedAutoBetCount.text = +e.target.text;
        PixiBase.changeFrame(this.autoBetButton, frameNames.AutoBetStopIcon);
        this.handleDoSpin();
      });
      this.autoBetPopupContainer.addChild(this.autoBetCount);
    });
  }

  setupSelectedAutoBetCount() {
    this.selectedAutoBetCount = PixiBase.createText('', {
      fontSize: isMobile() ? 17 : 19,
      fill: 'black',
      align: 'center',
      fontWeight: 700,
      fontFamily: 'Roboto',
    });
    const { x, y, anchor } = this.config.SpinBarContainer.selectedAutoBetCountConfig;
    PixiBase.setPosition(this.selectedAutoBetCount, { x: x, y: y });
    this.selectedAutoBetCount.anchor.set(anchor);
    this.SpinBarContainer.addChild(this.selectedAutoBetCount);
  }

  setupAutoBetCountPopup() {
    this.autoBetCountsPopup = PixiBase.createSprite(this.spriteSheet.autoBetCountsPopup);
    const { x, y, anchor } = this.config.SpinBarContainer.autoBetCountsPopupConfig;
    PixiBase.setPosition(this.autoBetCountsPopup, { x: x, y: y });
    this.autoBetPopupContainer.visible = false;
    this.autoBetCountsPopup.anchor.set(anchor);
    this.autoBetPopupContainer.addChild(this.autoBetCountsPopup);
    this.SpinBarContainer.addChild(this.autoBetPopupContainer);
  }

  setupGambleStartButton() {
    this.gambleStartButtonContainer = PixiBase.createContainer(
      frameNames.GambleStartButtonContainer
    );
    this.gambleStartButtonContainer.visible = false;
    const { x, y, anchor } = this.config.SpinBarContainer.gambleStartButtonContainerConfig;
    PixiBase.setPosition(this.gambleStartButtonContainer, { x: x, y: y });
    PixiBase.setupButtonMode(this.gambleStartButtonContainer, {
      interactive: true,
      buttonMode: true,
    });
    PixiBase.registerClick(this.gambleStartButtonContainer, () => {
      if (gambleStore.gambleCount && spinBarStore.isStoppedAllReels) {
        gameMainDrawer.gambleBar.updateAttemptLeftText(
          gameStore.canvasTranslationKeys.GAMBLE_ATTEMPTS_LEFT_TEXT
        );
        this.handleGambleStart();
      }
    });
    this.gambleStartButton = PixiBase.createSprite(this.spriteSheet.gambleStartButton);
    this.multiplierIcon = PixiBase.createSprite(this.spriteSheet.gambleIcon);
    this.gambleStartButton.anchor.set(anchor);
    this.multiplierIcon.anchor.set(anchor);
    this.gambleStartButtonContainer.addChild(this.gambleStartButton);
    this.gambleStartButtonContainer.addChild(this.multiplierIcon);
    this.SpinBarContainer.addChild(this.gambleStartButtonContainer);
  }

  execute(config, spriteSheet) {
    const [gameImageSpriteSheet] = spriteSheet;
    this.config = config;
    this.spriteSheet = gameImageSpriteSheet;
    const {
      SpinBarContainer: { spinBarContainerConfig },
    } = this.config;
    setContainersPosition(this.SpinBarContainer, spinBarContainerConfig);
    this.setupSpinButton();
    this.setupGraphicsForOutSideClick();
    this.setupAutoBetCountPopup();
    this.setupAutoBetCountsList();
    this.setupAutoBetInfinityCountButton();
    this.setupSpinButtonArrowsButton();
    this.setupAutoBetButton();
    this.setupSlowModeButton();
    this.setupSelectedAutoBetCount();
    this.setupGambleStartButton();
  }
}
